import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import ReactTable from "react-table";
import Button from "../../components/CustomButtons/Button.jsx";
import CustomSelect from "../../components/CustomInput/CustomSelect";
import { helper } from "../../../assets/js/utils/Element";
import AddBoxIcon from '@material-ui/icons/AddBox';
import NewProjectModal from "../../components/User/NewFileModal.js";
import LoaderComponent from '../../components/Loader';
import { Link as RouterLink } from "react-router-dom";
import DeleteConfirmationModal from "../../components/User/DeleteConfirmationModal";
import moment from 'moment';
import RefreshIcon from "@material-ui/icons/Refresh";

const Textract = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        this.state = {
            limit: 200,
            loading: false,
            page: 1,
            totalPages: 1,
            file: null,
            projects: null,
            languages: this.getLanguageOptions(),
            enableDisabledoptions: this.getEnableDisabledOptions(),
            values: {
                project: '',
                language: 'en-US',
                formDetection: 'disable',
                tableDetection: 'enable',
                receiptProcessing: 'disable',
            },
            response: null,
            creatingProject: false,
            newProjectModal: false,
            newProjectError: false,
            newProjectErrorMessage: null,
            loadingProjects: false,
            fileId: null,
            deleteModal: false,
            deleteingResult: false,
            saving: false,
            activeTab: 0,
        }

        this.hiddenFile = React.createRef();
        this.addFile = this.addFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onFileDelete = this.onFileDelete.bind(this);
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }
        this.loadProjects();
        this.loadResults();
    }
    getLanguageOptions(){
        return [
            {
                key: 'en-US',
                value: 'English'
            },
            {
                key: 'fr-FR',
                value: 'French'
            },
            {
                key: 'de-DE',
                value: 'German'
            },
            {
                key: 'it-IT',
                value: 'Italian',
            },
            {
                key: 'pt-PT',
                value: 'Portuguese',
            },
            {
                key: 'es-ES',
                value: 'Spanish'
            },
        ]
    }
    getLanguageName(language){
        const option = this.getLanguageOptions().find(opt => opt.key === language);
        return option ? option.value : language;
    }
    getEnableDisabledOptions(){
        return [
            {
                key: 'enable',
                value: 'Enable'
            },
            {
                key: 'disable',
                value: 'Disable'
            }
        ]
    }
    getTrProps(state, rowInfo){
        return {}
    }
    getTrGroupProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getColumns(){
        let columns = [
            
            {
                Header: "Created On",
                accessor: "created_at",
                headerClassName: "hd_creation_date",
                className: "hd_creation_date td_creation_date",
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if(a1<b1)
                    return 1;
                    else if(a1>b1)
                    return -1;
                    else
                    return 0;
                }
            },
            {
                Header: "Project Name",
                accessor: "project_name",
                headerClassName: "hd_name",
                className: "hd_name td_name",
            },
            {
                Header: "File Name",
                accessor: "file_name",
                headerClassName: "hd_name",
                className: "hd_name td_name",
            },
            {
                Header: "Language",
                accessor: "language",
                headerClassName: "hd_language",
                className: "hd_language td_language",
            },
            {
                Header: "Status",
                accessor: "status",
                headerClassName: "hd_status",
                className: "hd_status td_status",
            },
            {
                Header: "Format",
                accessor: "format",
                headerClassName: "hd_format",
                className: "hd_format td_format",
            },
            {
                Header: 'Task Type',
                accessor: 'type',
                headerClassName: 'hd_task_type',
                className: 'hd_task_type td_task_type',
            },
            {
                Header: "",
                accessor: "actions",
                headerClassName: "hd_actions",
                className: "hd_actions td_actions",
            }
        ]

        return columns;
    }
    getTableData(){
        const { response } = this.state;
        if(response === null){
            return [];
        }
        let tableData = [];
        
        response.map(file => {
            let fileArray = {
                id: file.id,
                created_at: this.getFormatedDate(file.created_at),
                project_name: file.project_name,
                file_name: file.file_name,
                language: this.getLanguageName(file.language),
                status: (
                    <span className={file.status}>{file.status_value}</span>
                ),
                format: file.format,
                type: this.getTypeText(file.type),
                actions: (
                    <div>
                        <Button justIcon color="transparent" title={"Download File"} onClick={() => this.downloadFile(file)}>
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z"/>
                            </svg>
                        </Button>
                        <RouterLink to={"/user/textract/result/"+file.id}>
                            <Button justIcon color="transparent" title={"View Textract Result"}>
                                <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM4.375 10H10.625C10.9688 10 11.25 10.2812 11.25 10.625C11.25 10.9688 10.9688 11.25 10.625 11.25H4.375C4.03125 11.25 3.75 10.9688 3.75 10.625C3.75 10.2812 4.03125 10 4.375 10ZM4.375 12.5H10.625C10.9688 12.5 11.25 12.7812 11.25 13.125C11.25 13.4688 10.9688 13.75 10.625 13.75H4.375C4.03125 13.75 3.75 13.4688 3.75 13.125C3.75 12.7812 4.03125 12.5 4.375 12.5ZM4.375 15H10.625C10.9688 15 11.25 15.2812 11.25 15.625C11.25 15.9688 10.9688 16.25 10.625 16.25H4.375C4.03125 16.25 3.75 15.9688 3.75 15.625C3.75 15.2812 4.03125 15 4.375 15Z"/>
                                </svg>
                            </Button>
                        </RouterLink>
                        <Button justIcon color="transparent" onClick={() => this.onDeleteResultModal(true, file.id)} title={"Delete"}>
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.94141 1.25H10.5547C10.7695 1.25 10.9688 1.35938 11.0859 1.54297L11.6836 2.5H5.81641L6.41406 1.54297C6.52734 1.35938 6.73047 1.25 6.94531 1.25H6.94141ZM13.1602 2.5L12.1484 0.882812C11.8047 0.332031 11.2031 0 10.5586 0H6.94141C6.29688 0 5.69531 0.332031 5.35156 0.882812L4.33984 2.5H2.50391H1.25H0.625C0.28125 2.5 0 2.78125 0 3.125C0 3.46875 0.28125 3.75 0.625 3.75H1.33984L2.33594 17.6797C2.42578 18.9883 3.51562 20 4.82812 20H12.6719C13.9844 20 15.0703 18.9883 15.1641 17.6797L16.1602 3.75H16.875C17.2188 3.75 17.5 3.46875 17.5 3.125C17.5 2.78125 17.2188 2.5 16.875 2.5H16.25H14.9961H13.1602ZM14.9102 3.75L13.918 17.5898C13.8711 18.2422 13.3281 18.75 12.6719 18.75H4.82812C4.17188 18.75 3.62891 18.2422 3.58203 17.5898L2.59375 3.75H14.9062H14.9102Z"/>
                            </svg>
                        </Button>
                    </div>
                ),
            };
            tableData.push(fileArray);
            return null;
        });
        return tableData;
    }
    getTypeText(type){
        let value = '';

        switch (type) {
            case "text":
                value = "Text Detection";
                break;
            case "form":
                value = "Form Analysis";
                break;
            case "table":
                value = "Table Analysis";
                break;
            case "receipt":
                value = "Receipt Analysis";
                break;
            default:
                value = "";
                break;
        }

        return value;
    }
    async downloadFile(file){
        if (!file.file_url) return;

        try {
            const response = await fetch(file.file_url, { method: 'GET' });
            const blob = await response.blob();

            const fileName = file.file_name || 'download';
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error('Download failed:', error);
        }
    }
    getFormatedDate(date){
        if(!date || date.length <= 0){
            return "";
        }
        return moment(date).format("MM/DD/YYYY HH:mm:ss");
    }
    loadResults(viewMore = false){
        const source = axios.CancelToken.source();
        
        let { page } = this.state;
        if(viewMore){
            page += 1;
        }else{
            page = 1;
        }

        this.setState({
            page: page,
            loading: (!viewMore), 
            loadingMore: viewMore,
            cancelToken: source,
        });

        let requestData = {
            page: page,
            limit: 200,
            today: true
        };
        
        Api.getResults(requestData, source).then(data => {
            const oldResponse = (viewMore ? this.state.response:[]);
            const response = oldResponse.concat(data.response);

            this.setState({
                response: response,
                loading: false,
                loadingMore: false,
                totalPages: data.totalPages,
                cancelToken: null
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    loadingMore: false,
                    cancelToken: null
                })
            }
        });
    }
    handleChange(event, name) {
        let value = event.target.value;

        let stateObj = {
            values: {
                ...this.state.values, 
                [name]: value
            }
        }
        if(name === 'formDetection'){
            if(value === 'enable'){
                stateObj.values['tableDetection'] = 'disable';
                stateObj.values['receiptProcessing'] = 'disable';
            }
        }else if(name === 'tableDetection'){
            if(value === 'enable'){
                stateObj.values['formDetection'] = 'disable';
                stateObj.values['receiptProcessing'] = 'disable';
            }
        }else if(name === 'receiptProcessing'){
            if(value === 'enable'){
                stateObj.values['formDetection'] = 'disable';
                stateObj.values['tableDetection'] = 'disable';
            }
        }

        this.setState(stateObj);
    }
    addFile = e => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedExtensions = ['pdf', 'png', 'jpeg', 'jpg'];
        const extension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            this.setState({
                file: null,
                errorMessage: "Only PDF, PNG, or JPEG files are allowed."
            });
            return;
        }

        this.setState({
            file: file,
            errorMessage: null
        });
    };
    onFocus = e => {
        this.hiddenFile.current.click(e);
    };
    onFileDelete(){
        this.setState({
            file: null
        });
    }
    processTextract(){
        const { values, file } = this.state;
        
        var requestData = new FormData();
        requestData.append('project', values.project);
        requestData.append('language', values.language);
        requestData.append('form', values.formDetection)
        requestData.append('table', values.tableDetection);
        requestData.append('receipt', values.receiptProcessing);
        requestData.append('file', file);

        const source = axios.CancelToken.source();
        this.setState({
            saving: true,
            cancelToken: source,
            showError: false,
        });

        const that = this;
        Api.addTextract(requestData, source).then(data => {
            that.setState({
                file: null,
                success: true,
                saving: false,
                response: [
                    ...this.state.response,
                    data.textract_result
                ]
            });
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    saving: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    onNewProjectModal(status = false){
        this.setState({
            newProjectError: false,
            newProjectErrorMessage: null,
            newProjectModal: status,
        });
    }
    onNewProjectModalSuccess(projectName){
        const source = axios.CancelToken.source();
        this.setState({
            creatingProject: true,
            cancelToken: source,
        });

        const requestData = {
            name: projectName,
        }
        Api.addNewProject(requestData, source).then(data => {
            this.setState({
                creatingProject: false,
                newProjectModal: false,
                newProjectError: false,
                newProjectErrorMessage: null,
                projects: [
                    ...this.state.projects,
                    data.project
                ]
            });
        }).catch(err => {
            console.log(err);
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    creatingProject: false,
                    newProjectErrorMessage: err.message,
                    newProjectError: true,
                    cancelToken: null
                });
            }
        });
    }
    loadProjects(){
        const source = axios.CancelToken.source();
        
        this.setState({
            loadingProjects: true, 
            cancelToken: source,
        });

        let requestData = {};
        
        Api.getProjects(requestData, source).then(data => {
            const defaultProject = (data.projects || []).find(p => p.default === 1);
            this.setState({
                projects: data.projects,
                loadingProjects: false,
                values: {
                    ...this.state.values,
                    project: defaultProject ? defaultProject.id : ''
                }
            });
        }).catch(err => {
            console.log(err);
        });
    }
    renderFile(file){     
        const { classes } = this.props;

        return <div className="file">
            <div className="file-header">
                <div className="file-details">
                    <span className={"file-icon"}>
                        { helper.getFileIcon(file, classes, true) }
                    </span>
                    <span className="file-detail">
                        <span className="file-name">{file.name}</span>
                        <span className="file-info">
                            <span className="file-type"></span>
                            <span className="file-size">{helper.getFormatedSize(file.size)}</span>
                        </span>
                    </span>
                </div>
                <div className="file-actions">
                    <div className={"filelist-action filelist-action-delete"}>
                        <svg onClick={() => this.onFileDelete()} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.74308 1.125H10.2531C10.4618 1.125 10.6554 1.22344 10.7692 1.38867L11.3498 2.25H5.65022L6.2308 1.38867C6.34085 1.22344 6.53817 1.125 6.74688 1.125H6.74308ZM12.7842 2.25L11.8013 0.794531C11.4674 0.298828 10.883 0 10.2569 0H6.74308C6.11696 0 5.53259 0.298828 5.19866 0.794531L4.21585 2.25H2.43237H1.21429H0.607143C0.273214 2.25 0 2.50312 0 2.8125C0 3.12188 0.273214 3.375 0.607143 3.375H1.30156L2.2692 15.9117C2.35647 17.0895 3.41518 18 4.69018 18H12.3098C13.5848 18 14.6397 17.0895 14.7308 15.9117L15.6984 3.375H16.3929C16.7268 3.375 17 3.12188 17 2.8125C17 2.50312 16.7268 2.25 16.3929 2.25H15.7857H14.5676H12.7842ZM14.4842 3.375L13.5203 15.8309C13.4748 16.418 12.9473 16.875 12.3098 16.875H4.69018C4.05268 16.875 3.52522 16.418 3.47969 15.8309L2.51964 3.375H14.4804H14.4842Z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    }
    textractButtonDisabled(){
        if(this.state.file === null){
            return true;
        }

        return false;
    }
    onDeleteResultModal(status = true, fileId = null){
        if(fileId === null && status === true){
            return;
        }
        this.setState({
            deleteModal: status,
            fileId: fileId
        });
    }
    onDeleteResultModalSuccess(){
        const { fileId } = this.state;

        const source = axios.CancelToken.source();

        this.setState({
            deleteingResult: true
        })
        
        Api.deleteResult(fileId, source).then(data => {
            this.setState({
                response: this.state.response.filter(p => p.id !== fileId),
                deleteModal: false,
                fileId: null,
                deleteingResult: false,
            });
        }).catch(err => {
            //Handle Error
        });
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<div key={key} className={"form-error-message passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </div>);
                key++;
            }
            return errorMessages;
        }
        return <div className={"form-error-message passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </div>;
    }
    onTabChange(urlTab){
        if(urlTab === '0'){
            this.setState({activeTab:0})
            this.history.push("/user/textract");
        }else if(urlTab === '1'){
            this.setState({activeTab:1})
            this.history.push("/user/textract/balance");
        }else if(urlTab === '2'){
            this.setState({activeTab:2})
            this.history.push("/user/textract/payments");
        }
    }
    render() {
        const { classes } = this.props;
        const { projects, languages, enableDisabledoptions, values, limit, newProjectModal, newProjectError, newProjectErrorMessage, 
            creatingProject, loadingProjects, file, deleteModal, loading, saving, deleteingResult, showError, 
            activeTab, totalPages, loadingMore, page } = this.state;
        const { authorized } = this.store.getState();
        const tableData = this.getTableData();
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.textractMainContainer}>
                    <div className={classes.content}>
                        <div className={classes.controls}>
                            <GridItem className={classes.controlsTabs}>
                                <div className='sd-custom-tabs'>
                                    <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                                        <span>Textract</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')} onClick={() => this.onTabChange("1")}>
                                        <span>My Balance</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')} onClick={() => this.onTabChange("2")}>
                                        <span>My Payments</span>
                                    </div>
                                </div>
                            </GridItem>
                            <div className={classes.controlButtons}></div>
                        </div>
                        <GridItem>
                            <div className={classes.textractContainer}>
                                <h5 className={classes.title}>Textract PDF & Image Files</h5>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} lg={4}>
                                        <div className={'browse-file-section'+(file === null ? ' select-file' : '')}>
                                            <input
                                                type="file"
                                                className={classes.inputFile}
                                                ref={this.hiddenFile}
                                                onChange={this.addFile}
                                                accept=".pdf,.png,.jpeg,.jpg"
                                                value=''
                                            />
                                            {
                                                file !== null ?
                                                    <div className='selected-file'>
                                                        {this.renderFile(file)}
                                                    </div>
                                                :
                                                    <div onClick={this.onFocus}>
                                                        <p className='drag-drop-text'>
                                                            Drag and Drop your file or
                                                            <Button link className="add-file-title">
                                                                Browse
                                                            </Button>
                                                        </p>
                                                        <p>[JPEG | JPG | PNG | PDF]</p>
                                                    </div>
                                            }
                                        </div>
                                        <div className="process-form-section">
                                            {
                                                showError ?
                                                    this.renderErrorMessages()
                                                :
                                                    <></>
                                            }
                                            <div className='project-select-create'>
                                                {
                                                    projects !== null ?
                                                        <>
                                                            <CustomSelect 
                                                                formControlProps={{
                                                                    fullWidth: true,
                                                                    className: 'custom-input body m-zero'
                                                                }}
                                                                labelText="Project Name"
                                                                selectProps={{
                                                                    onChange: (e) => this.handleChange(e,"project"),
                                                                    value: values.project,
                                                                }}
                                                                inputProps={{
                                                                    name: "project",
                                                                    id: "input-project",
                                                                    className: classes.alignLeft,
                                                                }}
                                                                items={projects}
                                                                itemLabel="name"
                                                                itemValue="id"
                                                                color="custom"
                                                            />
                                                            <Button justIcon color="custom" onClick={() => this.onNewProjectModal(true) } className='create-project-btn' title="Create New Project">
                                                                <AddBoxIcon />
                                                            </Button>
                                                        </>
                                                    :
                                                        loadingProjects ?
                                                            <LoaderComponent color="custom" align="left" />
                                                        :
                                                            <></>
                                                }
                                            </div>
                                            <CustomSelect 
                                                formControlProps={{
                                                    fullWidth: true,
                                                    className: 'custom-input body'
                                                }}
                                                labelText="File Language"
                                                selectProps={{
                                                    onChange: (e) => this.handleChange(e,"language"),
                                                    value: values.language,
                                                }}
                                                inputProps={{
                                                    name: "language",
                                                    id: "input-language",
                                                    className: classes.alignLeft,
                                                }}
                                                items={languages}
                                                itemLabel="value"
                                                itemValue="key"
                                                color="custom"
                                            />
                                            <CustomSelect 
                                                formControlProps={{
                                                    fullWidth: true,
                                                    className: 'custom-input body'
                                                }}
                                                labelText="Form Detection"
                                                selectProps={{
                                                    onChange: (e) => this.handleChange(e,"formDetection"),
                                                    value: values.formDetection,
                                                }}
                                                inputProps={{
                                                    name: "formDetection",
                                                    id: "input-formDetection",
                                                    className: classes.alignLeft,
                                                }}
                                                items={enableDisabledoptions}
                                                itemLabel="value"
                                                itemValue="key"
                                                color="custom"
                                            />
                                            <CustomSelect 
                                                formControlProps={{
                                                    fullWidth: true,
                                                    className: 'custom-input body'
                                                }}
                                                labelText="Table Detection"
                                                selectProps={{
                                                    onChange: (e) => this.handleChange(e,"tableDetection"),
                                                    value: values.tableDetection,
                                                }}
                                                inputProps={{
                                                    name: "tableDetection",
                                                    id: "input-tableDetection",
                                                    className: classes.alignLeft,
                                                }}
                                                items={enableDisabledoptions}
                                                itemLabel="value"
                                                itemValue="key"
                                                color="custom"
                                            />
                                            <CustomSelect 
                                                formControlProps={{
                                                    fullWidth: true,
                                                    className: 'custom-input body'
                                                }}
                                                labelText="Receipt Processing"
                                                selectProps={{
                                                    onChange: (e) => this.handleChange(e,"receiptProcessing"),
                                                    value: values.receiptProcessing,
                                                }}
                                                inputProps={{
                                                    name: "receiptProcessing",
                                                    id: "input-receiptProcessing",
                                                    className: classes.alignLeft,
                                                }}
                                                items={enableDisabledoptions}
                                                itemLabel="value"
                                                itemValue="key"
                                                color="custom"
                                            />
                                            <div className="process-form-btn">
                                                {
                                                    saving ?
                                                        <Button color="custom" type="button">
                                                            <LoaderComponent color="white" align="center" saving={true} />
                                                        </Button>
                                                    :
                                                        <Button color="custom" disabled={this.textractButtonDisabled()} onClick={() => this.processTextract()}>
                                                            Textract
                                                        </Button>
                                                }
                                            </div>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} lg={8}>
                                        <div className='tasks-section'>
                                            <div className='header-section'>
                                                <h5>Textract Tasks (Current Day)</h5>
                                            </div>
                                            <div className='tasks-table'>
                                                <ReactTable
                                                    columns={this.getColumns()}
                                                    data={tableData}
                                                    pageSizeOptions={[500]}
                                                    defaultPageSize={limit}
                                                    showPaginationTop={false}
                                                    minRows={0}
                                                    showPaginationBottom={false}
                                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable}
                                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                                    getNoDataProps={() => this.getNoDataProps()}
                                                />
                                                {
                                                    loading ?
                                                        <LoaderComponent color="custom" align="center" />
                                                    :
                                                        <></>
                                                }
                                                <div className={classes.loadMore}>
                                                    {
                                                        tableData.length > 0 && loadingMore === false && page < totalPages ?
                                                            <Button color="custom" id="contentViewMore" onClick={(e) => this.loadResults(true)}>
                                                                <RefreshIcon className={classes.icons} />View More
                                                            </Button>
                                                        :
                                                            loadingMore === true ?
                                                                <LoaderComponent color="custom" align="center" />
                                                            :
                                                                <></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </div>
                        </GridItem>
                    </div>
                </div>
                {
                    newProjectModal ?
                        <NewProjectModal
                            open={newProjectModal}
                            saving={creatingProject}
                            store={this.store} 
                            onClose={() => this.onNewProjectModal(false)}
                            onSuccess={(projectName) => this.onNewProjectModalSuccess(projectName)}
                            confirmationMessage="Create New Project"
                            error={newProjectError}
                            errorMessage={newProjectErrorMessage}
                            inputLabel="Project Name"
                        />
                    :
                        <></>
                }
                {
                    deleteModal ?
                        <DeleteConfirmationModal
                            confirmationMessage="Do you want to delete this textract result?"
                            open={deleteModal}
                            onClose={() => this.onDeleteResultModal(false)}
                            onSuccess={() => this.onDeleteResultModalSuccess()}
                            saving={deleteingResult}
                        />
                    :
                        <></>
                }
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

Textract.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(Textract);
